export default "__VITE_ASSET__DCwg1Sq4__"